import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LeadTypeClass {
  public contactInformationParams={
  statusCode: '',
  entityId: '',
  errorCode: '',
  errorMessage: '',
  odataContext: '',
  odataEtag: '',
  aciStateValueODataCommunityDisplayV1FormattedValue: '',
  aciStateValueMicrosoftDynamicsCrmAssociatednavigationproperty: '',
  aciStateValueMicrosoftDynamicsCrmLookuplogicalname: '',
  aciStateValue: '',
  address1City: '',
  address1Postalcode: '',
  aciLeadtypeODataCommunityDisplayV1FormattedValue: '',
  aciLeadtype: '',
  address1Stateorprovince: '',
  aciDivisionValueODataCommunityDisplayV1FormattedValue: '',
  aciDivisionValueMicrosoftDynamicsCrmAssociatednavigationproperty: '',
  aciDivisionValueMicrosoftDynamicsCrmLookuplogicalname: '',
  aciDivisionValue: '',
  companyname: '',
  aciZipcodeValueODataCommunityDisplayV1FormattedValue: '',
  aciZipcodeValueMicrosoftDynamicsCrmAssociatednavigationproperty: '',
  aciZipcodeValueMicrosoftDynamicsCrmLookuplogicalname: '',
  aciZipcodeValue: '',
  emailaddress1: '',
  lastname: '',
  mobilephone: '',
  firstname: '',
  telephone1: '',
  aciCompanysizeODataCommunityDisplayV1FormattedValue: '',
  aciCompanysize: '',
  leadid: '',
  address1Composite: '',
  aciStateOdataBind: '',
  aciZipCodeOdataBind: '',
  aciIscreatedfromportal: '',
  jobtitle:''
  }

  public billingParams={
    statusCode: '',
    entityId: '',
    errorCode: '',
    errorMessage: '',
    aci_billyourparticipantsinsurers:'',
    aci_employeesofthe: '',
    aci_insurancename: '',
    aci_employeeeligible: '',
    aci_noemployeeeligible: '',
    aci_eligiblefamilymembers: '',
    aci_collectpaymentfromparticipants: '',
    aci_billyourcompanydirectly: '',
    aci_responsibleforreimbursementtothepharmacy: '',
    aci_preferredinvoicestatement: '',
    aci_preferredinvoicebilling: '',
    }
}
